import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {take} from "rxjs/operators";
import {Exam} from "../../../shared/models/exam";
import {RescheduleExamSession} from "../../../shared/models/examSession";
import {ExamService} from "../../../shared/services/exam/exam.service";

@Component({
    selector: "app-exam-reschedule-modal",
    templateUrl: "./exam-reschedule-modal.component.html",
    styleUrls: ["./exam-reschedule-modal.component.scss"]
})
export class ExamRescheduleModalComponent implements OnInit {
    @Input() exam: Exam;

    rescheduleForm: FormGroup;
    sessions: Array<RescheduleExamSession> = [];
    isDataLoading: boolean = true;
    submitting: boolean = false;
    error: string;

    constructor (
        public activeModal: NgbActiveModal,
        private examService: ExamService,
        private toastr: ToastrService
    ) {}

    // La convocation part vers l'e-mail de la pré-inscription et mentionne la
    // certification : sans l'une ou l'autre, il n'y a rien à envoyer.
    get canSendConvocation (): boolean {
        return Boolean(this.exam.preregistration) && Boolean(this.exam.certification);
    }

    get selectedSession (): RescheduleExamSession | undefined {
        const sessionId = Number(this.rescheduleForm?.value.sessionId);

        return this.sessions.find((session) => session.id === sessionId);
    }

    ngOnInit () {
        this.rescheduleForm = new FormGroup({
            sessionId: new FormControl(null, Validators.required),
            sendConvocation: new FormControl({
                value: this.canSendConvocation,
                disabled: !this.canSendConvocation
            })
        });

        this.examService.rescheduleSessions(this.exam.id).pipe(take(1)).
            subscribe(
                (sessions) => {
                    this.sessions = sessions;
                    this.isDataLoading = false;
                },
                () => {
                    this.error = "Erreur lors du chargement des sessions";
                    this.isDataLoading = false;
                }
            );
    }

    validate () {
        if (this.rescheduleForm.invalid || this.submitting) {
            return;
        }

        this.submitting = true;
        this.error = null;

        const sendConvocation = this.canSendConvocation && this.rescheduleForm.value.sendConvocation;

        this.examService.reschedule(
            this.exam.id,
            Number(this.rescheduleForm.value.sessionId),
            sendConvocation
        ).pipe(take(1)).
            subscribe(
                ({exam, convocationSent}) => {
                    this.toastr.success("Ticket replanifié");

                    if (sendConvocation && !convocationSent) {
                        this.toastr.warning(
                            "Le ticket a été replanifié mais la convocation n'a pas pu être envoyée",
                            "Convocation"
                        );
                    }

                    this.activeModal.close(exam);
                },
                (err) => {
                    this.error = err.error?.detail || "Erreur lors de la replanification du ticket";
                    this.submitting = false;
                }
            );
    }
}
